/* eslint-disable @typescript-eslint/no-explicit-any */
import { IFormProps } from 'interface/inspection/InspectionInfo';
import { useState, useCallback } from 'react';

function useInputs(initData: IFormProps[]): any[] {
  const [form, setForm] = useState(initData);

  const onChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const { name, checked } = event.target;
      setForm(form.map((obj: any) => (obj.id === name ? { ...obj, value: checked } : obj)));
    },
    [form],
  );
  return [form, setForm, onChange];
}

export default useInputs;
